import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
const PopupReceiveGifts = (props) => {
  const { closeModal } = props;
  const [data, setData] = useState(props?.dataModalTopup);
  const navigate = useNavigate();
  // const closeModal = () => {
  //   document.body.classList.remove("modal-open");
  //   // localStorage.setItem("accessToken", "");
  //   // localStorage.setItem("userData", JSON.stringify({}));
  //   navigate("/");
  //   // setIsShowModalWhishNote(false);
  // };
  return (
    <>
      <div className="popup-overlay ">
        <div className="popup-warp">
          <div className="popup-inner">
            <div className="icon-popup"></div>
            <h3 className="name-popup">Chúc mừng!</h3>
            <div className="content-popup">
              <img
                className="img-animation"
                src="assets/img/bloom.png"
                alt="200.png"
              />
              <br />
              <br />
              <p>
                Xin chào,
                <br /> có ai đó vừa tặng quà cho bạn!
              </p>
            </div>

            <button
              type="button"
              className="btn btn-primary btn-block"
              onClick={props.clickAction}
            >
              Mở quà ngay
            </button>
          </div>
        </div>
      </div>
    </>
  );
};
export default PopupReceiveGifts;
